class growRatgeber {
	
	constructor() {
		this.elements = ""
		this.navigation = ""
		this.searchForm = ""
	}

	setNavigation() { 
		this.elements = document.querySelectorAll('.grow__newsheadline');
		this.navigationContainer = document.querySelector('.aside__content');
		this.elements.forEach(element => {
			this.navigationContainer.innerHTML += `<li><a data-nav onclick="GrowRatgeber.setActiveNavItem(this)" href="#${element.id}">${element.textContent}</a></li>`;
		});
	}

	setActiveNavItem(el) {
		const navItems = document.querySelectorAll('[data-nav]');
		const indicator = document.querySelector('.aside__indicator');
		navItems.forEach(item => {
			item.classList.remove('active');
		})
		el.classList.add('active');
		this.toggleSidebar()
		//get vertical offset of the element
		let offset = el.offsetTop;
		if(window.innerWidth > 1000) this.setIndicator();
	}

	setIndicator() {	
		const indicator = document.querySelector('.aside__indicator');
		indicator.classList.add('visible')
		const navItems = document.querySelectorAll('[data-nav]');
		navItems.forEach(item => {
			if (item.classList.contains('active')) {
				indicator.style.top = `${item.offsetTop + 15}px`
				console.log(item);
			} else { 

			}
		}
		)
	}

	resetIndicator() {	
		
		const indicator = document.querySelector('.aside__indicator');
		if (window.innerWidth <= 1000) { 
			indicator.style.top = ``
		} else { 
			setTimeout(this.setIndicator, 300)
		}
	}

	toggleDropdown(el) { 
		if (el.parentNode.classList.contains('active')) {
			el.parentNode.classList.remove('active');
		} else {
			el.parentNode.classList.add('active');
		}
	}

	toggleSidebar() {	
		if(window.innerWidth > 1000) return;
		const sidebar = document.querySelector('.aside__sticky');
		if (sidebar.classList.contains('active')) {
			sidebar.classList.remove('active');
		} else {
			sidebar.classList.add('active');
		}
	}


}

const GrowRatgeber = new growRatgeber();

document.addEventListener('DOMContentLoaded', function () {
	if (document.querySelector('.single-ratgeber')) {
		GrowRatgeber.setNavigation();
		window.addEventListener('resize', GrowRatgeber.resetIndicator)
	}
})
